import { RouteConfig } from 'vue-router'

function buildRoutes(_month: string, _title: string) {
  const Index = () => import(`../activity/splus-match/${_month}/Index.vue`)
  const Rewards = () => import(`../activity/splus-match/${_month}/Rewards.vue`)

  const monthForName = _month.split('-').join('_')

  const indexRoute: RouteConfig = {
    path: `/activity/splus-match/${_month}`,
    name: `activity_splus_match_${monthForName}`,
    component: Index,
    props: (_route) => ({ ..._route.query, ..._route.params }),
    meta: {
      title: _title,
    },
  }

  const rewardsRoute: RouteConfig = {
    path: `/activity/splus-match/${_month}/rewards`,
    name: `activity_splus_match_${monthForName}_rewards`,
    component: Rewards,
    props: (_route) => ({ ..._route.query, ..._route.params }),
    meta: {
      title: '我的奖品',
    },
  }

  return [indexRoute, rewardsRoute]
}

export default [...buildRoutes('2025-08', '夏日小工匠岛屿创造月')]
